module.exports = __webpack_public_path__ + "img/004-windows.866f1bb0.svg";